var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWatch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14",
    id: "Watch-Circle-Time--Streamline-Core",
    height: 14,
    width: 14,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Watch Circle Time Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "watch-circle-time--device-timepiece-circle-watch-round-time-clock-analog"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 975",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M7 4.875 7 7l1.25 1.25",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M7 11.5c2.48528 0 4.5 -2.01472 4.5 -4.5S9.48528 2.5 7 2.5 2.5 4.51472 2.5 7s2.01472 4.5 4.5 4.5Z",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9.5 3.25V1.5c0 -0.26522 -0.10536 -0.51957 -0.29289 -0.707107C9.01957 0.605357 8.76522 0.5 8.5 0.5h-3c-0.26522 0 -0.51957 0.105357 -0.70711 0.292893C4.60536 0.98043 4.5 1.23478 4.5 1.5v1.75",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9.5 10.7344V12.5c0 0.2652 -0.10536 0.5196 -0.29289 0.7071 -0.18754 0.1875 -0.44189 0.2929 -0.70711 0.2929h-3c-0.26522 0 -0.51957 -0.1054 -0.70711 -0.2929C4.60536 13.0196 4.5 12.7652 4.5 12.5v-1.7656",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatch);
export default __webpack_public_path__ + "static/media/Watch.9eb883daeca6b781834306b313a0d005.svg";
export { ForwardRef as ReactComponent };